import "core-js/modules/es.promise.js";
import { __assign } from "tslib";
import { uniCall } from '../../utils';
import { withDefaultOption } from '../../utils/with-default-option';
/**
 * 显示状态栏
 */

export function showStatusBar(opt) {
  return new Promise(function (resolve) {
    var option = withDefaultOption({
      color: 'black'
    }, opt);

    var param = __assign(__assign({}, option), {
      visible: true
    });

    uniCall({
      api: 'setStatusBar',
      param: param
    });
    resolve();
  });
}
/**
 * 隐藏状态栏
 */

export function hideStatusBar() {
  return new Promise(function (resolve) {
    var param = {
      visible: false
    };
    uniCall({
      api: 'setStatusBar',
      param: param
    });
    resolve();
  });
}